import * as React from 'react';
import CareersPage from './CareersPage';

export default () => <CareersPage/>;

